import React , { createRef  } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { PageHeader } from '../components/pageHeader/pageHeader';
import { Logo } from '../components/logo/logo';
import { PageHeaderNav } from '../components/pageHeaderNav/pageHeaderNav'
import { PageHeaderRight } from '../components/pageHeaderRight/pageHeaderRight'
import { IAccountPlan } from '../interface/plan';
import { getAccountPlan } from '../dataServices/getAccountPlan';

import './main.scss';

export function MainPage() {
    const [accountPlan, setAccountPlan] = useState<IAccountPlan | null>(null);
    const headerNavRef = createRef();

    useEffect(() => {
        getAccountPlan().then((ret) => {
            if (!ret.error_code && ret.data) {
                ret.data.teacher_status = Number(ret.data.teacher_status);
                setAccountPlan(ret.data);
            }
        });
    }, []);

    const handleLogoLoaded = useCallback(() => {
        if (headerNavRef && headerNavRef.current) {
            (headerNavRef.current as any)?.updateNavLayout();
        }
    }, [headerNavRef, headerNavRef.current])

    const renderLogo = useCallback(() => {
        return (
            <Logo
                trackEvent=""
                hideDefaultLogo={false}
                onLogoLoaded={handleLogoLoaded}
            ></Logo>
        )
    }, []);

    const renderNavs = () => {
        if (!accountPlan) {
            return null;
        }
        return (
            <div className="page-header-container">
                <PageHeaderNav ref={headerNavRef} versionType={accountPlan.teacher_status} />
                <PageHeaderRight accountPlan={accountPlan} />
            </div>
        );
    };

    return (
        <div className="main-page">
            <PageHeader
                showFixedHolder={false}
                renderLogo={renderLogo}
            >
                {renderNavs()}
            </PageHeader>
        </div>
    );
}
